/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { MDXProvider } from "@mdx-js/react"
import LazyPlot from "./plotly"
import PropTypes from "prop-types"

import { Link } from "gatsby"
import "./layout.css"
import styles from "./layout.module.scss"
import { Container, Typography } from "@material-ui/core"
import PageList from "../pages-list/page-list"

const components = {
  LazyPlot,
}

const Layout = ({ children }) => {
  const houseIcon = (
    <svg
      className="bi bi-house-door-fill"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: "bottom" }}
    >
      <path d="M6.5 10.995V14.5a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-7a.5.5 0 01.146-.354l6-6a.5.5 0 01.708 0l6 6a.5.5 0 01.146.354v7a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5V11c0-.25-.25-.5-.5-.5H7c-.25 0-.5.25-.5.495z" />
      <path
        fill-rule="evenodd"
        d="M13 2.5V6l-2-2V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5z"
        clip-rule="evenodd"
      />
    </svg>
  )

  return (
    <>
      <div className={styles.headerBackground}>
        <Container>
          <h1 className={styles.title}>
            <Link
              to="/"
              partiallyActive={true}
              activeClassName={styles.unstyledLink}
              activeStyle={{ textDecoration: "none" }}
            >
              {houseIcon} Zapata
            </Link>
          </h1>
        </Container>
      </div>
      <Container>
        <MDXProvider components={components}>
          <main>{children}</main>
          <footer>
            <hr />
            <PageList />
          </footer>
        </MDXProvider>
      </Container>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
